import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from './scenes/MainScene';

interface PhaserNPCFollowingDemoProps {
}

interface PhaserNPCFollowingDemoState {
}

const gameConfig: GameConfig = {
    title: "NPC Following Demo",
    version: "0.2-demo",
    backgroundColor: "#000000",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 300 }
        },
    },
};

class PhaserNPCFollowingDemo extends React.Component<PhaserNPCFollowingDemoProps, PhaserNPCFollowingDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserNPCFollowingDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserNPCFollowingDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={MainScene} config={gameConfig} />
        </div>);
    }
}

export default PhaserNPCFollowingDemo;



// WEBPACK FOOTER //
// ./src/games/demos/npcFollowingDemo/Main.tsx